class Person {
    constructor(civilite, nom, prenom) {

        this.civilite = civilite;
        this.prenom = prenom;
        this.nom = nom;

    }
}


export default Person;